import React, { Component } from "react";
import * as s from "./ThreeChoiceButton.module.scss";

export interface ChoiceButtonOption {
  value: string;
  label: string;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  options: ChoiceButtonOption[];
  selected: string;
  onChoiceClick: (choice: ChoiceButtonOption) => void;
}

export class ThreeChoiceButton extends Component<Props> {
  onButtonClick = title => {
    this.props.onChoiceClick(title);
  };

  renderButton = (option, key) => {
    const { selected } = this.props;
    let classes = [s.button];

    if (option.value == selected) {
      classes.push(s.selected);
    }

    return (
      <button
        className={classes.join(" ")}
        onClick={() => this.onButtonClick(option)}
        key={key}
      >
        {option.label}
      </button>
    );
  };

  render() {
    const { options = [], selected, className } = this.props;
    const classes = [s.threeChoiceButtonContainer];

    if (className) {
      classes.push(className);
    }

    return (
      <div
        className={classes.join(" ")}
        role="button"
        data-selected={options.findIndex(option => option.value == selected)}
      >
        {options.map(this.renderButton)}
      </div>
    );
  }
}
